import type { ReactNode } from 'react'
import type { To } from 'react-router'
import { BackLink } from '@/components/BackLink'

/**
 * "← Contacten" (design §2.3). A pass-through to U1's `BackLink` (spec-64, U-086): the
 * relation pages keep this name, so the pill itself lives in one place.
 */
export function RecordBackLink({ to, children }: { to: To; children: ReactNode }) {
  return <BackLink to={to}>{children}</BackLink>
}
